import { DeleteOutlined, DownloadOutlined, EditOutlined, EllipsisOutlined, EnterOutlined, SaveOutlined } from '@ant-design/icons'
import { Form, Input, notification, Popconfirm, Space, Button, Row, Col, Tabs, Select, Dropdown, Modal, Image, InputNumber } from 'antd'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { createIntroduce, detailIntroduce, updateIntroduce } from '../../../services/introduceService'
import { ReactSortable } from "react-sortablejs";
import { v4 as uuidv4 } from 'uuid';
import './detail.scss';
import { translate } from '../../../helper'
import MediaModal from '../../../components/Modal/ModalMedia'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { ImageDefault, editorConfiguration, itemCKeditor } from '../../../config/const'

function IntroduceDetail() {
    const navigate = useNavigate()
    const [form] = Form.useForm()
    const [dataForm, setDataForm] = useState({})
    const [loading, setLoading] = useState(false)
    const [items, setItem] = useState({
        vi: [],
        en: []
    });
    const [lang, setLang] = useState('vi');
    const [open, setOpen] = useState(false);
    const [index, setIndex] = useState();
    const [isModalVisible, setModalVisible] = useState(false);
    const [selectedMedia, setSelectedMedia] = useState(null);
    const [urlImage, setUrlImage] = useState("");
    const [form2] = Form.useForm()

    const params = useParams();

    const _detail = async (id) => {
        try {
            setLoading(true)
            const res = await detailIntroduce(id)
            if (!res.data || res.data.code !== 200) {
                return notification.warning({
                    message: res.data.message,
                })
            }
            const { actived, name, ordering, achievementLangs } = res.data.data;
            const dataform = {
                actived,
                name,
                ordering,
                achievementLangs:{
                    vi:[],
                    en:[]
                }
            };
            for (let i = 0; i < achievementLangs.length; i++) {
                const { langCode } = achievementLangs[i];
                dataform.achievementLangs[langCode].unshift(achievementLangs[i]);
            }
            setItem(dataform.achievementLangs);
            setDataForm(dataform)
            form.setFieldsValue(dataform)
        } catch (err) {
            console.log(err)
            notification.error({ message: err.message })
        } finally {
            setLoading(false)
        }
    }

    const submit = async () => {
        try {
            await form.validateFields();
            const { name,actived,ordering } = form.getFieldsValue();
            const body = {
                name,
                actived,
                ordering,
                achievementLangs: []
            };
            let isCheckTab = true;
            ['en', 'vi'].forEach(item => {
                if (!items[item]) {
                    isCheckTab = false
                }
            })
            if (!params.id && !isCheckTab) {
                return notification.warning({ message: 'Vui lòng kiểm tra lại thông tin' })
            }
            body.achievementLangs = items;
            if (!params.id) {
                const res = await createIntroduce(body)
                if (!res.data || res.data.code !== 200) {
                    return notification.warning({
                        message: res.data.message || 'Tạo cột mốc vàng son thất bại vui lòng thử lại!',
                    })
                }
                notification.success({ message: res.data.message })
            }
            if (params.id) {
                body.id = parseInt(params.id)
                const res = await updateIntroduce(body)
                if (!res.data || res.data.code !== 200) {
                    return notification.warning({
                        message: res.data.message || 'Chỉnh sửa cột mốc vàng son thất bại vui lòng thử lại!',
                    })
                }
                notification.success({ message: res.data.message })
            }
            navigate('/introduce')
        } catch (err) {
            if (err.errorFields?.length > 0) {
                return notification.warning({ message: 'Vui lòng kiểm tra lại thông tin' })
            }
            console.log(err)
            notification.error({ message: err.message })
        } finally {
        }
    }

    const _setItems = (value) => {
        if (value) {
            setItem(value)
        }
    }

    const _sortItems = (value) => {
        let itemsTmp = items;
        itemsTmp[lang] = value;
        if (itemsTmp) {
           setItem({ ...itemsTmp })
        }
    }

    const _addItems = () => {
        if(items[lang]?.length <= 5) {
            items[lang].push({
            id: uuidv4(),
            title: '',
            description: '',
            urlImage: '',
            positionsX: 0,
            positionsY: 0,
            });
            _setItems({ ...items })
        } else {
            return notification.warning({
                message: 'Bạn chỉ thêm được 6 cột mốc cho một danh sách',
            })
        }
    }

    const handleOpen = (index) => {
        setIndex(index);
        setUrlImage(items[lang][index].urlImage)
        form2.setFieldsValue(items[lang][index]);
        setOpen(true)
    }

    const handleMedia = (value) => {
        setSelectedMedia(value);
        setModalVisible(true)
    };
    
    const handleDeleteMedia = (value) => {
    if (value.field === "urlImage") {
        setUrlImage("");
    } 
    };

    const deleteMedia  = (index) => {
        let itemsTmp = items;
        itemsTmp[lang].splice(index,1)
        setItem({...items,...itemsTmp})
      }

    const submitEdit = () => {
        form2.validateFields().then(res => {
        const { title,description, positionsX, positionsY  } = form2.getFieldValue();
        items[lang][index].title = title;
        items[lang][index].description = description;
        items[lang][index].urlImage = urlImage;
        items[lang][index].positionsX = positionsX;
        items[lang][index].positionsY = positionsY;
        _setItems({ ...items });
          setOpen(false)
          form2.resetFields()
        })
    }

    useEffect(() => {
        if (params.id) {
            _detail(params.id);
        }
    }, [params.id]);

    const TABS = [
        {
            label: 'Tiếng Việt',
            key: 'vi',
        },
        {
            label: 'Tiếng Anh',
            key: 'en',
        }
    ]
    return (
        <Form
            form={form}
            layout="vertical"
            name="form_in_modal"
        >
            <Row gutter={16}>
                <Col span={16}>
                    <Tabs
                        type="card"
                        defaultActiveKey="2"
                        items={TABS}
                        onChange={(value) => setLang(value)}
                    />
                    <Button  type="primary" loading={loading} onClick={() => _addItems()}>
                        <SaveOutlined />
                        Thêm cột mốc
                    </Button>
                    <ReactSortable
                        animation={200}
                        delayOnTouchStart={true}
                        delay={2}
                        list={items && items[lang] ? items[lang] : []}
                        setList={(value) => _sortItems(value)}
                    >
                        {items && items[lang] && items[lang].map((item, index) => (
                            <div className="p-grid flex" key={index}>
                                <div className="draggableItem function-item" >
                                    <div className="btn-group w-100">
                                        <div
                                            className="btn inner-item dropdown-toggle func-item"
                                        >
                                            <div className='flex justify-center items-center'>
                                                <div className='index-introduce'>{index + 1}</div>
                                                <div className='ml-2'>
                                                    <Image src={ item.urlImage ? process.env.REACT_APP_API_ENDPOINT_DEV + item.urlImage : ImageDefault} style={{ width: "50px", height: "50px" }} />
                                                </div>
                                                <div className='flex justify-center items-center ml-2'>
                                                    <div>{item.title}</div>
                                                </div>
                                            </div>
                                            <Dropdown
                                                menu={{
                                                    items: [
                                                        {
                                                            key: '1',
                                                            label: (
                                                                <div className="action" onClick={() => { handleOpen(index) }}>
                                                                    <Space>
                                                                        <EditOutlined />
                                                                        <span>Tùy chỉnh</span>
                                                                    </Space>
                                                                </div>
                                                            ),
                                                        },
                                                        {
                                                            key: '2',
                                                            label: (
                                                                <div className="action" onClick={() => deleteMedia(index)}>
                                                                    <Space>
                                                                        <DeleteOutlined />
                                                                        <span>Xóa</span>
                                                                    </Space>

                                                                </div>
                                                            ),
                                                        },
                                                    ]
                                                }}
                                                placement="bottom"
                                                arrow
                                                trigger={'click'}
                                            >
                                                <EllipsisOutlined />
                                            </Dropdown>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </ReactSortable>
                </Col>
                <Col span={8} >
                    <div className="flex justify-end items-center mb-8">
                        <Space>
                            <Popconfirm
                                title={!params.id ? 'Xác nhận để tạo danh sách cột mốc' : 'Xác nhận để chỉnh sửa danh sách cột mốc'}
                                okText="Yes"
                                cancelText="No"
                                onConfirm={() => submit()}
                            >
                                <Button type="primary" loading={loading}>
                                    <SaveOutlined />
                                    Xác nhận
                                </Button>
                            </Popconfirm>
                            <Button danger onClick={() => navigate('/introduce')}>
                                <EnterOutlined />
                                Quay lại</Button>
                        </Space>
                    </div>
                    <Form.Item
                        name="name"
                        label={"Tên"}
                        rules={[{ required: true, message: 'Vui lòng nhập tên' }]}
                    >
                        <Input placeholder={"Nhập tên"} />
                    </Form.Item>
                    <Form.Item
                        label="Trạng thái"
                        name="actived"
                        rules={[{ message: 'Vui lòng chọn trạng thái', required: true }]}
                    >
                        <Select
                            placeholder={'Chọn trạng thái'}
                            style={{ width: '100%' }}
                            options={[
                                {
                                    value: 1,
                                    label: 'Hiển thị',
                                },
                                {
                                    value: 0,
                                    label: 'Ẩn hiển thị',
                                },
                            ]}
                        />
                    </Form.Item>
                    <Form.Item
                        name="ordering"
                        label={"Sắp xếp"}
                        style={{ width: "100%" }}
                    >
                        <InputNumber min={0} style={{ width: "100%" }} />
                    </Form.Item>
                </Col>
            </Row>
            <Modal
                open={open}
                title={translate("Chỉnh sửa", lang)}
                okText={translate("Xác nhận", lang)}
                cancelText={translate("Hủy", lang)}
                onCancel={() => {
                    setOpen(false);
                    form2.resetFields()
                 }
                }
                onOk={() => submitEdit()}
                width={'70%'}
                className="top-5"
            >
                <Form
                    form={form2}
                    layout="vertical"
                    name="form"
                    className="gap-5"
                >
                    <Form.Item
                        name={'title'}
                        label={translate("Năm cột mốc", lang)}
                    >
                        <Input placeholder={translate("Nhập năm cột mốc", lang)} />
                    </Form.Item>
                   <Form.Item

                        name={['description']}
                        label={translate("Mô tả", lang)}
                        rules={[{ required: false }]}
                    >
                    <CKEditor
                         editor={Editor}
                         config={ editorConfiguration }
                        data={params && params.id && items[lang] && items[lang][index] ? items[lang][index].description : ''}
                        onChange={(event, editor) => {
                            const data = editor.getData();
                            form2.setFieldValue(['description'],data)
                        }}
                        onReady={(editor) => {
                            // editorInstance[lang] = editor;
                          }}
                        />
                    </Form.Item> 
                    <Form.Item
                        name={'urlImage'}
                        label={translate("Hỉnh ảnh", lang)}
                    >
                        <Image
                        src={urlImage ? process.env.REACT_APP_API_ENDPOINT_DEV + urlImage : ImageDefault}
                        />
                    </Form.Item>
                    <Button className='mb-4' onClick={() => handleMedia({ key: 'single', type: 'image', field: 'urlImage' })} icon={<DownloadOutlined />} >
                         Upload
                    </Button>  
                    <Form.Item
                        name={'positionsX'}
                        label={translate("Tọa độ X", lang)}
                    >
                        <InputNumber placeholder={translate("Nhập tọa độ X", lang)} className='w-full'/>
                    </Form.Item>
                    <Form.Item
                        name={'positionsY'}
                        label={translate("Toạ độ Y", lang)}
                    >
                        <InputNumber placeholder={translate("Nhập tọa độ Y", lang)} className='w-full'/>
                    </Form.Item>
                </Form>
            </Modal>
            <MediaModal isModalVisible={isModalVisible} setModalVisible={setModalVisible} setValue={(value) => setUrlImage(value[0].url)} selectedMedia={selectedMedia}></MediaModal>
        </Form>
    )
}

export default IntroduceDetail